module.exports = __webpack_public_path__ + "img/banker-purple_900.5a4ce9f4.png";